import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export type StrongPasswordRequirement =
  | 'length'
  | 'lowercase'
  | 'uppercase'
  | 'digit'
  | 'special';

export interface StrongPasswordError {
  missing: StrongPasswordRequirement[];
}

const MIN_LENGTH = 8;

export function checkStrongPassword(
  value: string,
): Record<StrongPasswordRequirement, boolean> {
  return {
    length: value.length >= MIN_LENGTH,
    lowercase: /[a-z]/.test(value),
    uppercase: /[A-Z]/.test(value),
    digit: /\d/.test(value),
    special: /[^A-Za-z0-9]/.test(value),
  };
}

export function strongPasswordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value ?? '';
    if (!value) return null;

    const checks = checkStrongPassword(value);
    const missing = (Object.keys(checks) as StrongPasswordRequirement[]).filter(
      (k) => !checks[k],
    );

    if (missing.length === 0) return null;
    return { strongPassword: { missing } satisfies StrongPasswordError };
  };
}
